import React, { useEffect, useState } from 'react';
import { base_url } from '../../Api/Api';
import { Loader } from '../../Global/Loader';

import ItemWinner from './itemWinner';

const LotteryExpire = (props) => {

    const [state, setState] = useState({
        data: null,
        loader: true,
        awards:null
    })

    useEffect(() => {


        base_url.get(`lottery/${props.match.params.id}`)
            .then(response => {
              var items = response.data.lottert.awards;
              
              items.sort(function (a, b) {
                return a.rank - b.rank;
              });
              console.log(items)

                setState({
                    ...state,
                    data: response.data.lottert,
                    awards:items,
                    loader: false
                })

            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <div className="instructpg lottery">

            <Loader
                active={state.loader} />

            <div className="Header">
                <span className="cat-title">
                    جزییات قرعه کشی
                    <i
                        className="icon-arrow-down-sign-to-navigate"
                        onClick={() => props.history.goBack()} ></i>
                </span>
            </div>
            <div className="body-lottery">
                <h4>{state.data == null ? '' : state.data.title}</h4>
                <span className="title-ltr">جزییات قرعه کشی</span>
                {state.data == null ?
                    <span className="no-content">اطلاعاتی وجود ندارد</span>
                    :
                    <p>{state.data.description}</p>
                }
                <span className="title-ltr">جوایز برندگان</span>
                <div className="list-winner">
                    {state.data == null ?
                        <span className="no-content">اطلاعاتی وجود ندارد</span>
                        :
                        state.awards.length == 0 ?
                            <span className="no-content">اطلاعاتی وجود ندارد</span>
                            :
                            state.awards.map(item =>
                                item.user == null 
                                ? (<span className="winner">
                                    <span>{item.title}</span>
                                    <span>{item.description}</span>
                                  </span>) 
                                :
                                  <ItemWinner
                                    title={`${item.user.name} ${item.user.last_name}`}
                                    description={item.description}
                                    image={item.user.profile_photo_url}
                                    grade={item.rank} />
                            )
                    }
                </div>
            </div>
        </div>
    );
}

export default LotteryExpire;